import { css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

/**
 * Inline icon atom. Associates icon and text.
 *
 * icon - Icon of the icon-inline atom.
 * text - Text content of the icon-inline atom.
 */
@customElement('nn-icon-inline')
export class IconInline extends LitElement {
  static styles = css`
    .icon-inline {
      align-items: center;
      background: none;
      border: 0;
      border-radius: 0;
      box-shadow: none;
      color: var(--nn-icon-inline_icon-inline_color, #fff);
      display: flex;
      font-family: var(--nn-icon-inline_icon-inline_font-family, 'font-medium');
      font-size: var(--nn-icon-inline_icon-inline_font-size, 0.8em);
      justify-content: left;
      line-height: 1;
      margin: 0;
      padding: 0;
      text-align: left;
      text-decoration: none;
      text-transform: none;
      vertical-align: inherit;
      width: 100%;
    }
    .icon-inline--text {
      padding: var(--nn-icon-inline_icon-inline--text_padding, 0 0 0 8px);
    }
  `;

  render() {
    return html`
      <div class="icon-inline single">
        <slot name="icon"></slot>
        <div class="icon-inline--text">
          <slot name="text"></slot>
        </div>
      </div>
    `;
  }
}
